export default {
  SolutionFaceIn: {
    imgUrl: require('../img/banner/banner_facein_face.jpg'),
    title: 'FaceIn人脸核身',
    info: '高准确率、高安全性的人脸核身解决方案',
    info2: '国内第一家在金融行业全量上线',
    buttonText: '联系我们',
    xlsxUrl: 'https://www.qcloud.com/solution/face-recognition',
    newPage: true
  },
  SolutionAuditing: {
    imgUrl: require('../img/banner/banner_you_safe.jpg'),
    title: '内容安全',
    info: '识别图像中可能令人反感、不安全或不适宜内容，',
    info2: '一体化接入，节约人力成本'
  },
  SolutionBroadcast: {
    imgUrl: require('../img/banner/banner_you_video.jpg'),
    title: '视频直播',
    info: '「主播核身+美颜特效」 既安全，又有趣',
    buttonText: '联系我们',
    xlsxUrl: 'https://www.qcloud.com/product/mi',
    newPage: true
  },
  SolutionInvoice: {
    imgUrl: require('../img/banner/banner_cwpj.jpg'),
    title: '财务票据',
    info: '财务票据数字化解决方案',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  },
  SolutionEducation: {
    imgUrl: require('../img/banner/banner_edu.jpg'),
    title: '优图教育',
    info: '优图教育OCR解决方案',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  },
  SolutionSDKProduction: {
    imgUrl: require('../img/banner/banner_sdk.jpg'),
    title: '腾讯优图移动端泛娱乐产品',
    info: '帮助您轻松接入娱乐类SDK产品，丰富您的移动端社交娱乐产品',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  },
  SolutionInsurance: {
    imgUrl: require('../img/banner/banner_znbx.jpg'),
    title: '智能保险',
    info: '基于优图OCR服务，提供保险行业中核保、理赔等场景的智能识别解决方案',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  },
  SolutionVideoUnderstand: {
    imgUrl: require('../img/banner/banner_splj.jpg'),
    title: '视频理解解决方案',
    info: '可对用户上传的视频、图片进行内容理解、内容审核、内容编辑，精准投放用户，节省人工成本'
  },
  SolutionFaceInFW: {
    imgUrl: require('../img/banner/banner_facein_antifake.jpg'),
    title: 'FaceIn人脸防伪',
    info: '精准识别虚假人脸，提高影像鉴别能力',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  },
  SolutionTim: {
    imgUrl: require('../img/banner/banner_tim.png'),
    title: '腾讯云智媒体AI中台',
    info: '为传媒行业量身打造，集合顶尖AI能力的全栈式AI服务管理平台'
  },
  SolutionForgery: {
    imgUrl: require('../img/banner/product_banner_id.jpg'),
    title: '优图证件鉴伪解决方案',
    info: '精准鉴伪，轻松实现高效风控反欺诈',
    buttonText: '联系我们',
    xlsxUrl: 'https://ai.qq.com/contact/?from=youtu',
    newPage: true
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/solution/panels/data/BannerConstant.js